import { createRequestTypes } from 'common/websocket-redux';

export const GET_USER_BENEFIT_FLEX_DOLLARS = createRequestTypes(
  'service/GET_USER_BENEFIT_FLEX_DOLLARS',
);

export const SET_USER_BENEFIT_FLEX_DOLLARS = createRequestTypes(
  'service/SET_USER_BENEFIT_FLEX_DOLLARS',
);
